import { ReactElement } from 'react'
import { I18n } from 'common'
import { defaultTheme } from '../../../../../../src/theme/index'
import styled from 'styled-components'
import { useUserStore } from '../../../../../../src/store/user/UserStore'
import { UserAttributeKey } from '../../../../../../src/store/user/interfaces'
import CrossReferenceButton from '../CrossReferenceButton'
import { breakpoints } from '../../../../../../src/theme/breakpoints'

interface Props {
  partType?: string
  partNumber?: string
  manufacturer?: string
}

const InterchangeDisclaimer = (props: Props): ReactElement => {
  const { partType, partNumber, manufacturer } = props
  const userStore = useUserStore()
  const crossReference: boolean =
    userStore.getUserAttribute(UserAttributeKey.crossReference) === 'true'

  return (
    <Wrapper>
      <InfoSection>
        <GroupInfo>
          {partType && <span>{partType} | </span>}{' '}
          {partNumber && <span>{partNumber} | </span>}
          {manufacturer && <span>{manufacturer}</span>}
        </GroupInfo>
        <DisclaimerText>
          <I18n name="interchangeDisclaimer" />
        </DisclaimerText>
      </InfoSection>

      <CrossFerenceBtnWrapper>
        {crossReference && <CrossReferenceButton partNumber={partNumber} />}
      </CrossFerenceBtnWrapper>
    </Wrapper>
  )
}

const Flex = styled.div`
  display: flex;
`

const Wrapper = styled(Flex)`
  flex: 1;
  min-width: 0;
  justify-content: space-between;
  align-items: center;
  width: 100%;

  @media screen and (width <= ${breakpoints.mobileLarge}px) {
    flex-wrap: wrap;
    align-items: flex-start;
    gap: 10px;
  }
`

const InfoSection = styled.div`
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 4px;
`

const GroupInfo = styled.div`
  font-weight: 700;
  line-height: 24px;
  text-transform: uppercase;

  @media screen and (width <= ${breakpoints.mobileLarge}px) {
    line-height: 20px;
  }
`

const DisclaimerText = styled.span`
  display: block;
  font-size: 11px;
  line-height: 16px;
  color: ${defaultTheme.colors.black};
`

const CrossFerenceBtnWrapper = styled.div`
  flex-shrink: 0;
`

export default InterchangeDisclaimer
